// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"integration-btn_wrapper__HWE_1","button":"integration-btn_button__JJM8g"};